import styled from 'styled-components';

export const prefixCls = 'ui-upload';

export const UploadSC = styled.div`
  display: inline-block;
  max-width: 100%;

  .ui-upload-wrapper {
    width: fit-content;
    height: fit-content;

    .rc-upload {
      display: block;
    }
  }
`;

export const DragAreaSC = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  border-radius: 10px;
  border: 2px solid ${({ theme }) => theme.color.border.regular};
  background: ${({ theme }) => theme.color.surface.variant};

  transition: all 0.2s;

  .ui-upload-disabled & {
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.5;
  }

  &.ui-form-field-error {
    border: 2px solid ${({ theme }) => theme.color.border.error} !important;
    background: ${({ theme }) => theme.color.surface.error};
  }

  &:hover {
    .circle-picker {
      border: 2px solid
        ${({ theme }) => theme.createOverlayColor(theme.color.border.regular, 'hover')} !important;
      background: ${({ theme }) => theme.createOverlayColor(theme.color.surface.variant, 'hover')};
    }

    &.ui-form-field-error {
      .circle-picker {
        border: 2px solid
          ${({ theme }) => theme.createOverlayColor(theme.color.border.error, 'hover')} !important;
        background: ${({ theme }) => theme.createOverlayColor(theme.color.surface.error, 'hover')};
      }
    }
  }

  .ui-upload-drag-hover & {
    border: 2px solid ${({ theme }) => theme.color.solid.selection};
  }
`;
